import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { EmpresaPermisoRepository } from 'app/core/domain/repositories/empresa-permiso.repository';
import { EmpresaPermisoEntity } from 'app/core/domain/entities/empresa-permiso.entity';
import { Result, NetworkError } from 'app/core/domain/common';
import { environment } from 'environments/environment';

@Injectable()
export class EmpresaPermisoHttpRepository extends EmpresaPermisoRepository {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/api/empresa-permiso/v1`;

  asignar(empresaId: number, permisoId: number): Observable<Result<EmpresaPermisoEntity, NetworkError>> {
    return this.http.post<any>(`${this.baseUrl}/asignar`, { empresaId, permisoId }).pipe(
      map((response) => Result.ok<EmpresaPermisoEntity, NetworkError>(
        EmpresaPermisoEntity.fromPersistence(response.data)
      )),
      catchError((error) =>
        of(Result.fail<EmpresaPermisoEntity, NetworkError>(NetworkError.fromHttpError(error)))
      )
    );
  }

  getByEmpresa(empresaId: number): Observable<Result<EmpresaPermisoEntity[], NetworkError>> {
    return this.http.get<any>(`${this.baseUrl}/empresa/${empresaId}`).pipe(
      map((response) => {
        const items: EmpresaPermisoEntity[] = response.data.map(
          (item: any) => EmpresaPermisoEntity.fromPersistence(item)
        );
        return Result.ok<EmpresaPermisoEntity[], NetworkError>(items);
      }),
      catchError((error) =>
        of(Result.fail<EmpresaPermisoEntity[], NetworkError>(NetworkError.fromHttpError(error)))
      )
    );
  }
}
